import * as Types from '../actions/ActionTypes';

const initialState = {
    navigations: {
        isLoading: true,
        data: []
    },

}

const NavigationReducer = function (state = initialState, action) {
    switch (action.type) {
        case Types.GET_USER_NAVIGATION_PENDING: {
            return {
                ...state,
                navigations: {
                    isLoading: true,
                    data: [...initialState.navigations.data]
                },
            }
        }
        case Types.GET_USER_NAVIGATION_SUCCESS: {
            return {
                ...state,
                navigations: {
                    isLoading: false,
                    data: action.payload
                },
            }
        }
        case Types.GET_USER_NAVIGATION_FAILED: {
            return {
                ...state,
                navigations: {
                    isLoading: false,
                    data: [...initialState.navigations.data]
                },
            }
        }
        default: {
            return {
                ...state,
            }
        }
    }
}

export default NavigationReducer
